module.exports = __webpack_public_path__ + "static/img/visa-1.a0b4642.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/visa/visa-1.png
// module id = 262
// module chunks = 6